<template>
  <div>
    <vx-card>        
      <h3 class="gw-det-title">Archivos</h3>
      <p class="gw-det-sub">Documentos adjuntos al proceso.</p>  
      <vs-list>
        <vs-list-item :title="project_archive.title" v-for="(project_archive, index_project_archive) in visibleArchives" :key="index_project_archive">
          <vs-button class="button-report" type="gradient" style="background: #640064;" @click="downloadArchive(project_archive)">Descargar archivo</vs-button>    
        </vs-list-item>
      </vs-list>           
    </vx-card>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import api from '@/mixins/api.js'
import secureFiles from '@/mixins/secureFiles.js'
import { isPresignedOrExternalFileUrl } from '@/utils/secureFileUrl'

export default {
  mixins: [api, secureFiles],
  props: {
    project: Object
  },
  data() {
    return {
      clientLogo: '',
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        }
      }
    }
  },
  computed: {
    visibleArchives () {
      const archives = (this.project && this.project.project_archives) || []
      return archives.filter((archive) => isPresignedOrExternalFileUrl(archive.url))
    }
  },
  methods: {
    downloadArchive (archive) {
      this.openSecureFileUrl(archive.url, {
        resourceType: archive.resource_type || 'project_archive',
        id: archive.id,
        attachment: archive.attachment
      })
    }
  },
  components:{
    swiper,
    swiperSlide
  }
}
</script>

<style>

</style>
